// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2

export const dashboardTheme = ['light', 'dark', 'system'];
export const dashboardLanguages = { 'de-DE': 'Deutsch', 'en-US': 'English' };
